import script from "./RatingCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingCircle.vue?vue&type=script&setup=true&lang=js"

import "./RatingCircle.vue?vue&type=style&index=0&id=21d5565b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d5565b"]])

export default __exports__